import styled from 'styled-components';

export default styled.label`
  flex: 1;
  cursor: pointer;
`;
